import { NavigationService } from '@ib-core-services/navigation.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';

import { IRouteItem } from '../interfaces/route-item.intf';

export const ROUTES_CONFIG: Array<IRouteItem> = [
  {
    title: 'page-title.home',
    icon: 'account_balance_wallet',
    routePath: NavigationService.getRouteSegmentsByRoute(IB_ROUTES.DASHBOARD),
    route: IB_ROUTES.DASHBOARD,
    useInBreadcrumbs: true,
  },
  {
    title: 'page-title.withdraw',
    icon: 'payments',
    routePath: NavigationService.getRouteSegmentsByRoute(IB_ROUTES.WITHDRAW),
    route: IB_ROUTES.WITHDRAW,
    useInBreadcrumbs: true,
  },
  // {
  //   title: 'Account Activity',
  //   icon: 'list_alt',
  //   routePath: NavigationService.getRouteSegmentsByRoute(IB_ROUTES.ACTIVITY),
  //   route: IB_ROUTES.ACTIVITY,
  //   useInBreadcrumbs: true,
  // },
];

export function getRouteConfig(type: IB_ROUTES): IRouteItem {
  return ROUTES_CONFIG.find(i => i.route === type);
}
